const ERR_CODE_ = '';
export const ERR_CODE_SERVER = 500;
export const ERR_CODE_INITFAIL = 501;
export const ERR_CODE_NVCFAIL = 400013;
export const ERR_CODE_REPEAT = 100001;

export const SKIP_NOT = 'NOT';
export const SKIP_OPTION = 'OPTION';
export const SKIP_UNCONDI = 'UNCONDI';
export const SKIP_DEFAULT_KEY = '_default';
export const SKIP_OPT_NOT = 'NOT';
export const SKIP_OPT_END = 'END';
export const SKIP_OPT_INVALID = 'INVALID';

export const FIELD_TYPE_TEXT = 'Text';
export const FIELD_TYPE_TEXTAREA = 'Textarea';
export const FIELD_TYPE_RADIO = 'Radio';
export const FIELD_TYPE_CHECKBOX = 'Checkbox';
export const FIELD_TYPE_IMAGERADIO = 'ImageRadio';
export const FIELD_TYPE_IMAGECHECKBOX = 'ImageCheckbox';
export const FIELD_TYPE_CITYSELECT = 'CitySelect';
export const FIELD_TYPE_PHONE = 'Phone';
export const FIELD_TYPE_IDNUMBER = 'IDNumber';

export const enumTypes = [
  FIELD_TYPE_RADIO,
  FIELD_TYPE_CHECKBOX,
  FIELD_TYPE_IMAGERADIO,
  FIELD_TYPE_IMAGECHECKBOX,
];
export const textTypes = [
  FIELD_TYPE_TEXT,
  FIELD_TYPE_TEXTAREA,
];

export const PHONE_REGEX_HMT = [
  /^(5|6|9)\d{7}$/, // 香港
  /^6\d{7}$/,       // 澳门
  /^09\d{8}$/,      // 台湾 
];
export const PHONE_REGEX_OVERSEA = [
  /^0\d{9}$/,                                        // 日本
  /^01[016789]-?\d{3,4}-?\d{4}$/,                    // 韩国
  /^\+?1?\s*\(?(\d{3})\)?[\s.-]?\d{3}[\s.-]?\d{4}$/, // 美国
  /^\+?44\s*([0-9]{4}|\d{5})\s*\d{6}$/,              // 英国
  /^\+?61\s*([0-9]{1})\s*([0-9]{4})\s*([0-9]{4})$/,  // 澳大利亚
];
export const PHONE_REGEX_MAINLAND = [
  /^1[3-9]\d{9}$/,
];

export const IDNUMBER_REGEX_CHINAID = [
  /^\d{17}[\dXx]$/,
];

// 地区选择组件
export const CITYSELECT_LEVEL_DISTRICT = 'district';
export const CITYSELECT_LEVEL_CITY = 'city';
export const CITYSELECT_LEVEL_PROVINCE = 'province';


export const LOCALE_CN = 'zh_CN';
export const LOCALE_TW = 'zh_TW';
export const LOCALE_EN = 'en_US';

const DEFAULT_LOCALE = LOCALE_EN;

export const localeMap = {
  [LOCALE_CN]: {
    submit: '提交',
    requiredMsg: '该内容必填',
    minMsg: '该内容最小输入位数：',
    phoneLooseMsg: '格式错误，仅支持数字',
    phoneStrictMsg: '格式错误',
    idNumberLooseMsg: '格式错误，仅支持数字、英文字母',
    multiSelectTag: '【多选题】',
    requiredInput: '输入值不能为空',
    refresh: '点击重新加载',
    inputPlaceholder: '请输入',
    selectPlaceholder: '请选择',
    [ERR_CODE_SERVER]: '服务器错误，请重试',
    [ERR_CODE_INITFAIL]: '加载失败',
    [ERR_CODE_NVCFAIL]: '验证失败',
    [ERR_CODE_REPEAT]: '请勿重复填写',
  },
  [LOCALE_TW]: {
    submit: '提交',
    requiredMsg: '該內容必填',
    minMsg: '此內容最小輸入位數：',
    phoneLooseMsg: '格式錯誤，僅支援數字',
    phoneStrictMsg: '格式錯誤',
    idNumberLooseMsg: '格式錯誤，僅支援數字、英文字母',
    multiSelectTag: '【多選題】',
    requiredInput: '輸入值不能為空',
    refresh: '點擊重新加載',
    inputPlaceholder: '請輸入',
    selectPlaceholder: '請選擇',
    [ERR_CODE_SERVER]: '伺服器錯誤，請重試',
    [ERR_CODE_INITFAIL]: '加載失敗',
    [ERR_CODE_NVCFAIL]: '驗證失敗',
    [ERR_CODE_REPEAT]: '请勿重复填写',
  },
  [LOCALE_EN]: {
    submit: 'SUBMIT',
    requiredMsg: 'This content is required',
    minMsg: 'Minimum number of input digits for this content:',
    phoneLooseMsg: 'Format error, only numbers supported',
    phoneStrictMsg: 'Format error',
    idNumberLooseMsg: 'Format error, only supports numbers and English letters',
    multiSelectTag: '[Multiple choice questions]',
    requiredInput: 'Input value cannot be empty',
    refresh: 'Click to reload',
    inputPlaceholder: 'Please enter',
    selectPlaceholder: 'Please choose',
    [ERR_CODE_SERVER]: 'Server error, please try again',
    [ERR_CODE_INITFAIL]: 'Loading failed',
    [ERR_CODE_NVCFAIL]: 'Verification Failed',
    [ERR_CODE_REPEAT]: 'Please do not fill out again',
  },
};

export function i18n(locale, key) {
  const localeData = localeMap[locale];
  return (localeData && localeData[key]) || (localeMap[DEFAULT_LOCALE][key]) || key;
}

export const locales = [
  {
    label: '简体中文',
    value: 'zh_CN',
  },
  {
    label: '繁体中文',
    value: 'zh_TW',
  },
  {
    label: '英文',
    value: 'en_US',
  },
];

export const fontWeight = [
  {
    label: 'Thin',
    value: 200,
  },
  {
    label: 'Light',
    value: 300,
  },
  {
    label: 'Normal',
    value: 400,
  },
  {
    label: 'Medium',
    value: 500,
  },
  {
    label: 'Bold',
    value: 600,
  },
];

